<template lang="pug">
#tabela-infos-publica-bndes-pf
    BaseTableHeader(
        :icone-titulo-tabela='iconeTituloTabela',
        :titulo-tabela='tituloTabela'
    )

    div(v-if='items.length > 0')
        el-table(
            :data='paginatedItems',
            style='width: 100%; height: 100%',
            :default-sort='{ prop: "valorContratacao", order: "ascending" }',
            stripe,
            v-loading='isLoading'
        )
            el-table-column(type='expand')
                template(slot-scope='props')
                    el-descriptions.descricao-item-tabela(
                        :size='"mini"',
                        :column='3',
                        direction='vertical'
                    )
                        el-descriptions-item.has-colon-not(
                            :label='$t("mensagens.preAnaliseCredito.informacoesPublicasBndes.instituicaoFinanceiraCredenciada")'
                        ) {{ formatarTexto(props.row.agenteFinanceiro) }}
                        el-descriptions-item.has-colon-not(
                            :label='$t("mensagens.preAnaliseCredito.informacoesPublicasBndes.valorDesembolsado")'
                        ) {{ formatNumberExpanded(props.row.valorDesembolsado_vf) }}
                        el-descriptions-item.has-colon-not(
                            :label='$t("mensagens.preAnaliseCredito.informacoesPublicasBndes.custoFinanceiro")'
                        ) {{ formatarTexto(props.row.custoFinanceiro) }}
                    el-descriptions.descricao-item-tabela.mt-3(
                        :size='"mini"',
                        :column='5',
                        direction='vertical'
                    )
                        el-descriptions-item.has-colon-not(
                            :label='$t("mensagens.preAnaliseCredito.informacoesPublicasBndes.taxaDeJuros")'
                        ) {{ formatarTextoJuros(props.row.taxaJuros) }}%
                        el-descriptions-item.has-colon-not(
                            :label='$t("mensagens.preAnaliseCredito.informacoesPublicasBndes.prazoDeCarencia")'
                        ) {{ formatarTexto(props.row.prazoCarencia) }} {{ $t('mensagens.preAnaliseCredito.informacoesPublicasBndes.meses') }}
                        el-descriptions-item.has-colon-not(
                            :label='$t("mensagens.preAnaliseCredito.informacoesPublicasBndes.uf")'
                        ) {{ formatarTexto(props.row.uf) }}
                        el-descriptions-item.has-colon-not(
                            :label='$t("mensagens.preAnaliseCredito.informacoesPublicasBndes.municipio")'
                        ) {{ formatarTexto(props.row.municipio) }}
                        el-descriptions-item.has-colon-not(
                            :label='$t("mensagens.preAnaliseCredito.informacoesPublicasBndes.prazoDeAmortizacao")'
                        ) {{ formatarTexto(props.row.prazoAmortizacao) }} {{ $t('mensagens.preAnaliseCredito.informacoesPublicasBndes.meses') }}
                    el-descriptions.descricao-item-tabela.mt-3(
                        :size='"mini"',
                        :column='3',
                        direction='vertical'
                    )
                        el-descriptions-item.has-colon-not(
                            :label='$t("mensagens.preAnaliseCredito.informacoesPublicasBndes.setorBndes")'
                        ) {{ formatarTexto(props.row.setorApoiado_sfm) }}
                        el-descriptions-item.has-colon-not(
                            :label='$t("mensagens.preAnaliseCredito.informacoesPublicasBndes.subsetirBndes")'
                        ) {{ formatarTexto(props.row.subsetorApoiado_sfm) }}
                        el-descriptions-item.has-colon-not(
                            :label='$t("mensagens.preAnaliseCredito.informacoesPublicasBndes.setorCnae")'
                        ) {{ formatarTexto(props.row.cnae_sfm) }}
            el-table-column(
                :label='$t("mensagens.preAnaliseCredito.informacoesPublicasBndes.produto")',
                prop='produtoBndes_sfm',
                align='left',
                min-width='140px'
            )
            el-table-column(
                :label='$t("mensagens.preAnaliseCredito.informacoesPublicasBndes.data")',
                prop='dataContratacao',
                :formatter='formatarDataTableColumn',
                min-width='80px',
                align='left'
            )
            el-table-column(
                :label='$t("mensagens.preAnaliseCredito.informacoesPublicasBndes.valorContratadoReais")',
                prop='valorContratacao',
                :formatter='formatNumber',
                min-width='100px',
                sortable,
                align='right'
            )
            el-table-column(
                :label='$t("mensagens.preAnaliseCredito.informacoesPublicasBndes.situacao")',
                prop='liquidada',
                align='left',
                min-width='60px'
            )
            el-table-column(
                :label='$t("mensagens.preAnaliseCredito.informacoesPublicasBndes.formaDeApoio")',
                prop='operacaoDireta_sfm',
                align='left',
                min-width='80px'
            )
        .d-flex.flex-row.justify-content-between.align-items-center.border-bottom
            .tabela-rodape-somatorio(v-if='dados.response.docs.length > 0')
                p {{ dados.response.numFound }} {{ $t('mensagens.preAnaliseCredito.informacoesPublicasBndes.operacoes') }}
            el-pagination(
                v-if='dados.response.docs.length > 0',
                :page-size='8',
                :pager-count='5',
                layout='prev, pager, next',
                :total='dados.response.numFound',
                @prev-click='avancarPagina',
                @next-click='voltarPagina',
                @current-change='atualizarPagina'
            )
    el-alert(
        v-else,
        :title='$t("mensagens.preAnaliseCredito.informacoesPublicasBndes.naoHaRegistroParaInformacoesPublicasBndes")',
        type='warning',
        :closable='false'
    )
</template>

<script>
import formatters from '@/utils/formatters';

import preAnaliseServiceMixin from '@/modules/pre-analise-credito/mixins/PreAnaliseCreditoMixin';

import BaseTableHeader from '@/modules/pre-analise-credito/components/BaseTableHeader';

export default {
    name: 'TabelaInfosPublicasBndesPf',

    components: {
        BaseTableHeader
    },

    mixins: [preAnaliseServiceMixin],

    props: {
        tituloTabela: {
            type: String,
            required: true,
            default: 'Tabela'
        },
        iconeTituloTabela: {
            type: String,
            required: true,
            default: 'mdi mdi-cloud-search-outline'
        },
        dados: {
            type: Array,
            required: true,
            default: () => []
        }
    },

    data() {
        return {
            dadoSelecionado: null,
            items: [],
            paginaAtual: 1,
            itemsPorPagina: 8,
            isLoading: false
        };
    },

    created() {
        this.items = this.dados.response.docs;
    },

    computed: {
        totalPages() {
            return Math.ceil(this.items.length / this.itemsPorPagina);
        },
        paginatedItems() {
            const startIndex = (this.paginaAtual - 1) * this.itemsPorPagina;
            const endIndex = startIndex + this.itemsPorPagina;
            return this.items.slice(startIndex, endIndex);
        }
    },

    methods: {
        formatNumber(row, column, number, index) {
            return formatters.formatNumber(number, 2);
        },
        formatNumberExpanded(number) {
            return formatters.formatNumber(number, 2);
        },
        formatarDataTableColumn(row, column, data, index) {
            return this.mxFormatarData(data);
        },
        formatarTexto(texto) {
            if (!texto) {
                return '- -';
            } else {
                return texto.join(', ');
            }
        },
        formatarTextoJuros(texto) {
            let arrayTextos = [];
            texto.forEach(el => {
                arrayTextos.push(Number(el).toFixed(2));
            });
            return arrayTextos.join(', ');
        },
        voltarPagina() {
            this.handleLoadingTable();
            setTimeout(() => {
                if (this.paginaAtual > 1) {
                    this.paginaAtual--;
                }
            }, 550);
        },
        avancarPagina() {
            this.handleLoadingTable();
            setTimeout(() => {
                if (this.paginaAtual < this.totalPages) {
                    this.paginaAtual++;
                }
            }, 550);
        },
        atualizarPagina(pagina) {
            this.handleLoadingTable();
            setTimeout(() => {
                this.paginaAtual = pagina;
            }, 550);
        },
        handleLoadingTable() {
            this.isLoading = true;
            setTimeout(() => {
                this.isLoading = false;
            }, 500);
        }
    }
};
</script>

<style lang="scss">
#tabela-infos-publica-bndes-pf {
    font-family: 'Roboto', 'sans serif' !important;
    border-radius: 5px 5px 0 0 !important;
    height: calc(100vh - 312px);

    h1 {
        border-bottom: 1px solid #359138;
        margin-bottom: 18px;
        width: 100%;
        line-height: 42px;
    }

    i.mdi {
        color: var(--primary);
        margin-right: 10px;
        font-size: 24px;
    }

    .tabela-titulo {
        color: var(--primary);
        font-size: 18px;
        font-weight: 400;
        line-height: 21px;
        letter-spacing: 0em;
        text-align: left;
    }

    .el-table {
        border: 1px solid #d9d9d9;
        border-radius: 5px;
        height: 100%;

        .descricao-item-tabela {
            margin-left: 55px;
            margin-right: 55px;
            max-height: 100px;
            overflow-y: auto;
        }

        .el-table__expand-icon {
            height: 24px;
            width: 24px;
            margin-bottom: 10px;
        }

        .el-table__expand-icon > .el-icon {
            color: #3b3b3b;
            font-weight: 700;
            font-size: 16px;
        }

        thead {
            color: var(--primary);
            font-size: 16px;
            font-weight: 500;
            line-height: 18.75px;
        }

        .el-descriptions-row {
            .el-descriptions-item__label {
                color: var(--primary);
                font-weight: 500;
                font-size: 16px;
                line-height: 18.75px;
            }
        }
        .el-descriptions-item__label.has-colon::after {
            content: '';
        }
    }

    .tabela-rodape-somatorio p {
        margin-bottom: 0;
        color: var(--primary);
        font-size: 14px;
        font-weight: 500;
        line-height: 16px;
        padding: 17px 0 15px 21px;
    }
    .el-pagination {
        padding: 16px 75px 16px 0;
        color: #3b3b3b;
    }
    .el-pager li.active {
        color: #00413c;
        font-weight: 600;
        font-size: 15px;
        background: #00413c24;
    }
}
</style>
